import axios from "../axios";

const getSectionPayments = (id) => {
    return axios.get(`/docflow/resolutions/${id}/payment/list`)
        .then(response => response.data);
}

const addPayments = (id, form) => {
    return axios.post(`/docflow/resolutions/${id}/payment/add`, form)
        .then(response => response.data);
}

const deletePayment = (paymentId) => {
    return axios.post(`/docflow/resolutions/payment/${paymentId}`)
        .then(response => response.data)
}

const getPayment = (id) => {
    return axios.get(`/docflow/resolutions/payment/${id}`)
        .then(response => response.data);
}

const updatePayment = (resolutionId, paymentId, form) => {
    return axios.post(`/docflow/resolutions/${resolutionId}/payment/${paymentId}/edit`, form)
        .then(response => response.data);
}

const paymentNotRequired = (resolutionId) => {
    return axios.post(`/docflow/resolutions/${resolutionId}/payment-not-required`)
        .then(response => response.data);
}

const confirmPayments = (resolutionId) => {
    return axios.post(`/docflow/resolutions/${resolutionId}/confirm-payments`)
        .then(response => response.data);
}

const paymentChangeRequest = (resolutionId, form) => {
    return axios.post(`/docflow/resolutions/${resolutionId}/change-request`, form)
        .then(response => response.data)
}

const getMainPayments = (id) => {
    return axios.get(`/docflow/resolutions/main/${id}/payments`)
        .then(response => response.data);
}

const getDefaultSigners = (resolutionId) => {
    return axios.get(`/docflow/resolutions/main/${resolutionId}/default-signers`)
        .then(response => response.data);
}

const confirm = (id, form) => {
    return axios.post(`/docflow/resolutions/main/${id}/confirm`, form)
        .then(response => response.data);
}

const signPayment = (id, form) => {
    return axios.post(`/docflow/resolutions/main/payment/${id}/sign`, form)
        .then(response => response.data)
}

const returnMainPayment = (id, form) => {
    return axios.post(`/docflow/resolutions/main/payment/${id}/return`, form)
        .then(response => response.data)
}

const paymentCalculateTaxes = (id, form) => {
    return axios.post(`/docflow/resolutions/main/payment/${id}/calculate-taxes`, form)
        .then(response => response.data)
}

const accountantSignPayment = (id, form) => {
    return axios.post(`/docflow/resolutions/main/payment/${id}/accountant-sign`, form)
        .then(response => response.data)
}

const applicationPayments = (id) => {
    return axios.get(`/docflow/applications/${id}/payments`)
        .then(response => response.data);
}

const confirmApplicationPayment = (applicationId, paymentId) => {
    return axios.post(`/docflow/applications/${applicationId}/payments/${paymentId}/confirm`)
        .then(response => response.data)
}

const paymentRequestReject = (paymentRequestId, form) => {
    return axios.post(`/docflow/resolutions/main/payment-requests/${paymentRequestId}/reject`, form)
        .then(response => response.data)
}

const paymentRequestAccept = (paymentRequestId) => {
    return axios.post(`/docflow/resolutions/main/payment-requests/${paymentRequestId}/accept`)
        .then(response => response.data)
}

const getMainHistoryPayments = (resolutionId, mainPaymentId) => {
    return axios.get(`/docflow/resolutions/main/${resolutionId}/payments/${mainPaymentId}`)
        .then(response => response.data);
}

const attachPaymentOrder = (paymentMainId, form) => {
    return axios.post(`/docflow/resolutions/main/payment/${paymentMainId}/attach-payment-order`, form)
        .then(response => response.data)
}

export default {
    getSectionPayments,
    addPayments,
    deletePayment,
    getPayment,
    updatePayment,
    paymentNotRequired,
    confirmPayments,
    paymentChangeRequest,
    getMainPayments,
    getDefaultSigners,
    confirm,
    returnMainPayment,
    signPayment,
    paymentCalculateTaxes,
    accountantSignPayment,
    applicationPayments,
    confirmApplicationPayment,
    paymentRequestReject,
    paymentRequestAccept,
    getMainHistoryPayments,
    attachPaymentOrder,
};
